var map = {
	"./2008.jpg": "1483",
	"./ConstructionManagement.jpg": "8ff2",
	"./CreativeServices.jpg": "4705",
	"./DesignFabrication.jpg": "1b3c",
	"./DigitalSolutions.jpg": "dfe7",
	"./ExperientialMarketing.jpg": "4b1a",
	"./ITSolutions.jpg": "5ded",
	"./MeetingsCorporateTheatre.jpg": "535a",
	"./Open_Sans/OpenSans-Bold.ttf": "154b",
	"./Open_Sans/OpenSans-BoldItalic.ttf": "e189",
	"./Open_Sans/OpenSans-ExtraBold.ttf": "8e4e",
	"./Open_Sans/OpenSans-ExtraBoldItalic.ttf": "5a82",
	"./Open_Sans/OpenSans-Italic.ttf": "a3f2",
	"./Open_Sans/OpenSans-Light.ttf": "c7ed",
	"./Open_Sans/OpenSans-LightItalic.ttf": "d223",
	"./Open_Sans/OpenSans-Regular.ttf": "aaf2",
	"./Open_Sans/OpenSans-SemiBold.ttf": "fb1b",
	"./Open_Sans/OpenSans-SemiBoldItalic.ttf": "4c75",
	"./ProductCultureTraining.jpg": "26e5",
	"./ProgramManagement.jpg": "c0a8",
	"./Using_Computer.jpeg": "8b45",
	"./afterEvent.jpeg": "b926",
	"./atEvent.jpeg": "5345",
	"./hero.jpg": "6ee5",
	"./jd_logo_white.png": "0913",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";